<template>
  <modal
    name="imagesModal"
    adaptive
    :width="1000"
    :height="600"
    classes="wf-shadow-xl wf-rounded-lg wf-bg-gray-100"
    @before-open="beforeOpen"
    @closed="closed"
  >
    <div class="wf-h-full wf-flex wf-flex-wrap">
      <div
            class="wf-overflow-scroll wf-p-4 wf-relative wf-h-full wf-bg-white image-media-container"
            :class="selectedImage ? ['wf-w-3/4'] : ['wf-w-full']"
        >
            <div class="wf-w-full">
                <h4 class="wf-text-blue-700 wf-font-bold wf-lowercase">
                <i class="fas fa-images"></i> Media Library</h4>
                <div class="wf-border-blue-700 wf-w-12 wf-border-2"></div>
            </div>
            <div class="wf-mt-4 wf-flex wf-flex-wrap">
                <div
                    v-for="image in originalImages"
                    :key="image.id"
                    class="wf-flex wf-items-center wf-justify-center wf-mb-4 wf-w-1/6"
                >
                    <div
                        @click.prevent="selectedImage == image ? selectedImage = null : selectedImage = image"
                        :class="thumbnailClasses(image)"
                        class="media-thumbnail wf-cursor-pointer wf-rounded-lg wf-border-4 wf-relative hover:wf-border-blue-600 wf-border-transparent"
                    >
                        <div
                            class="wf-rounded wf-bg-center wf-bg-cover wf-relative wf-h-full wf-w-full"
                            :style="`background-image: url(${image.path})`"
                        ></div> 
                        <div
                            v-if="selectedImage == image"
                            style="top: -10px;right: -10px;"
                            class="wf-absolute wf-bg-blue-600 wf-flex wf-h-5 wf-items-center wf-justify-center wf-rounded-full wf-text-white wf-text-xs wf-w-5"
                        >
                            <i class="fas fa-check"></i>
                        </div>
                    </div>
                </div>
            </div>
            <label
                for="upload-image"
                class="wf-bottom-0 wf-right-0 wf-mr-4 wf-mb-4 wf-bg-blue-500 wf-border-radius wf-cursor-pointer wf-flex wf-h-16 hover:wf-bg-blue-600 wf-shadow-md hover:wf-shadow-lg wf-items-center wf-justify-center wf-absolute wf-rounded-full wf-text-sm wf-text-white wf-uppercase wf-w-16 wf-z-50"
            >
                <i class="fas fa-upload"></i>
                <input @change="uploadImages" type="file" class="wf-hidden" multiple accept="image" id="upload-image">
            </label>
        </div>
      <div v-if="selectedImage" class="wf-flex wf-flex-col wf-border-l wf-p-4 wf-w-1/4 wf-bg-gray-100 wf-h-full image-media-container">
            <div class="wf-flex wf-justify-center wf-items-center">
                <img :src="selectedImage.path" ref="selectedImage" class="wf-h-40 wf-shadow wf-rounded" alt="">
            </div>
            <div class="wf-mt-2 wf-flex wf-justify-between wf-items-center">
                <span
                    class="wf-font-light wf-lowercase wf-text-gray-600 wf-text-xs wf-tracking-wid wf-leading-tight"
                    v-text="`${imageNaturalWidth}x${imageNaturalHeight}px`"
                >
                </span>
                <span class="wf-font-light wf-lowercase wf-text-gray-600 wf-text-xs wf-tracking-wide wf-leading-tight">October 12th 1985</span>
            </div>
            <div class="wf-mt-4">
                <ul class="wf-flex wf-flex-col">
                    <li class="wf-mt-3 wf-w-full">
                        <span class="wf-block wf-font-light wf-lowercase wf-text-gray-500 wf-text-xs wf-tracking-wide">alternative text</span>
                        <input type="text" class="wf-w-full focus:wf-bg-gray-300 wf-text-xs wf-bg-gray-300 wf-text-gray-700 wf-border wf-rounded focus:wf-outline-none wf-px-2 wf-py-1">
                    </li>
                    <li class="wf-mt-3 wf-w-full">
                        <span class="wf-block wf-font-light wf-lowercase wf-text-gray-500 wf-text-xs wf-tracking-wide">title</span>
                        <input type="text" class="wf-w-full focus:wf-bg-gray-300 wf-text-xs wf-bg-gray-300 wf-text-gray-700 wf-border wf-rounded focus:wf-outline-none wf-px-2 wf-py-1">
                    </li>
                    <li class="wf-mt-3 wf-w-full">
                        <span class="wf-block wf-font-light wf-lowercase wf-text-gray-500 wf-text-xs wf-tracking-wide">link</span>
                        <input
                            readonly
                            @click.prevent="copyToClipboard"
                            class="wf-w-full focus:wf-outline-none focus:wf-bg-gray-300 wf-cursor-pointer wf-text-xs wf-bg-gray-300 wf-text-gray-500 wf-border wf-rounded focus:wf-outline-none wf-px-2 wf-py-1"
                            :value="selectedImage.path"
                        >
                    </li>
                </ul>
            </div>
            <div class="wf-mt-auto">
                <button
                    @click.prevent="addImage"
                    class="wf-bg-green-500 focus:wf-outline-none hover:wf-bg-green-600 hover:wf-shadow-lg wf-py-2 wf-rounded-full wf-shadow wf-text-center wf-text-sm wf-text-white wf-uppercase wf-w-full"
                >Select image</button>
            </div>
        </div>
    </div>
  </modal>
</template>

<script>
  import axios from 'axios'
  import ArrayManipulation from '../mixins/ArrayManipulation'
  export default {
    mixins: [ArrayManipulation],
    data() {
      return {
        currentImage: null,
        alt: null,
        device: null,
        module: null,
        imageNaturalHeight: 0,
        imageNaturalWidth: 0,
        selectedImage: null,
        images: [],
        imageElement: null,
        video: null,
        sectionIndex: null,
        rowIndex: null,
        columnIndex: null,
        componentIndex: null,
      }
    },

    watch: {
      selectedImage(value) {
        if (! value) {
          return
        }
        this.$nextTick(() => {
          if (! this.$refs.selectedImage) {
            return
          }
          this.imageNaturalWidth = this.$refs.selectedImage.naturalWidth  
          this.imageNaturalHeight = this.$refs.selectedImage.naturalHeight
        })
      }
    },

    computed: {
      element() {
        let element = {
          section: this.sectionIndex,
          row: this.rowIndex,
          column: this.columnIndex,
          component: this.componentIndex,
          componentSection: this.componentSectionIndex,
          componentRow: this.componentRowIndex,
          componentColumn: this.componentColumnIndex,
          componentComponent: this.componentComponentIndex,
        }

        let newElement = Object.keys(element)
          .filter(key => element[key] != null)
          .reduce((obj, key) => {
            obj[key] = element[key]
            return obj
          }, new Object)

        return newElement
      },

      originalImages() {
        return this.images.filter(image => image.size == 'original')
      },
      assets() {
        return this.$store.getters['assetModule/assets']
      },
    },

    methods: {
      newImages(image, withSizes = false) {
        let images = [
          {
            alt: this.alt,
            image: image.path,
            size: image.size,
            element: this.imageElement,
            touched: false
          }
        ]
        if(withSizes) {
          let sizes = this.images.filter(arrayImage => arrayImage.file_id == image.id).map(arrayImage => {
            return {
              alt: this.alt,
              image: arrayImage.path,
              size: arrayImage.size,
              element: this.imageElement,
              touched: false
            }
          })
          sizes.push(...images)
          images = sizes
        }
        return images
      },
      thumbnailClasses(image) {
        let classes = this.selectedImage ? ['wf-h-24', 'wf-w-24'] : ['wf-h-32', 'wf-w-32']
        if (this.selectedImage == image) {
          classes.push('wf-border-blue-600')
        }
        return classes
      },
      beforeOpen(event) {
        this.sectionIndex = event.params.section
        this.rowIndex = event.params.row
        this.device = event.params.device
        this.columnIndex = event.params.column
        this.componentIndex = event.params.component
        this.componentSectionIndex = event.params.componentSection
        this.componentRowIndex = event.params.componentRow
        this.componentColumnIndex = event.params.componentColumn
        this.componentComponentIndex = event.params.componentComponent
        this.module = event.params.module
        this.imageElement = event.params.element
        if (event.params.currentImage) {
          this.currentImage = event.params.currentImage
          this.selectedImage = this.currentImage.image
        }
        if (this.imageElement == 'videoPoster') {
          this.video = event.params.video
        }
        this.getImages()
      },
      closed() {
        this.images = []
        this.imageElement = null
        this.sectionIndex = null
        this.device = null
        this.rowIndex = null
        this.columnIndex = null
        this.componentIndex = null
        this.componentSectionIndex = null
        this.componentRowIndex = null
        this.componentColumnIndex = null
        this.componentComponentIndex =  null
        this.selectedImage = null
        this.imageNaturalWidth = null
        this.imageNaturalHeight = null
      },
      formData(files) {
        let formData = new FormData
        for (let x = 0; x < files.length; x++) {
          formData.append('files[]', files[x])
        }
        return formData
      },
      getImages() {
        axios.get('/files.json')
           .then(response => this.images = response.data)
           .catch(error => console.log(error.response.data))
      },
      addImage() {
        if (! this.selectedImage) {
          return
        }
        this.handleImage()
        this.$modal.hide('imagesModal')
      },
      handleImage() {
        if(this.imageElement == 'videoPoster') {
          return this.handleVideoPoster()
        }
        if(this.imageElement == 'sourceImage') {
          return this.handleSourceImage()
        }
        return this.handleBackgroundImage()
      },
      handleVideoPoster() {
        let videoLink = this.video ? this.video.video : ''
        this.removeFromArray(this.module, [this.video], 'assets', this.device)
        this.addToArray(this.module, [{
          video: videoLink,
          poster: this.selectedImage
        }], 'assets', this.device)
      },
      handleSourceImage() {
        let images = this.newImages(this.selectedImage, true)
        this.removeFromArray(this.module, [this.currentImage], 'assets', this.device)
        this.addToArray(this.module, images, 'assets', this.device)
      },
      handleBackgroundImage() {
        this.removeFromArray(this.module, [this.currentImage],'assets', this.device)
        this.addToArray(this.module, this.newImages(this.selectedImage), 'assets', this.device)
      },
      copyToClipboard(event) {
        event.target.select()
          document.execCommand('copy')
          window.getSelection ? window.getSelection().removeAllRanges() : document.selection.empty()          
      },
      uploadImages(event) {
        if (! event.target.files.length) {
          return
        }
        axios.post('/files', this.formData(event.target.files), {
          headers: {'Content-Type': 'multipart/form-data'}
        }).then(response => this.images.push(...response.data.data))
          .catch(error => console.log(error.response.data))
      }
    }
  }
</script>